<template>
    <div>
        <app-header
            :title="'Review mistakes'"
            :redirect-on-close="'/'"
            :closeable="true"
        />
        <section class="container" v-if="questions">
            <div v-for="question in questions" class="panel bg--layer-darker pt--20 pb--20 mb--md">
                <div class="text--lg mb--10"><strong>{{ question.question.question }}</strong></div>
                <div class="c--success text--sm mb--sm text--review"><i class="material-icons">check</i>
                    <strong>{{ question.good_answer.answer }}</strong>
                </div>
                <div class="c--danger text--sm mb--0 text--review"><i class="material-icons">close</i>
                    <strong v-if="question.bad_answer">{{ question.bad_answer.answer }}</strong>
                    <div class="profile__avatar"><span class="profile__avatar__img">
                        <img :src="avatar" alt=""></span></div>
                </div>
            </div>
        </section>
        <loading v-else />
    </div>
</template>

<script>

import api from "../api/gameReview";
import { mapGetters } from 'vuex'
import AppHeader from "./partial/AppHeader";

export default {
    name: "GameReview",
    components: {AppHeader},
    props: {
        quizId: {
            default: null,
            type: String
        },
    },

    data: function () {
        return {
            questions: null
        }
    },

    computed: {
        ...mapGetters('auth', [
            'avatar',
        ]),
    },

    methods: {
        loadQuestions() {
            api.getQuestions(this.quizId).then((response) => {
                this.questions = response.data
            })
        }
    },

    created() {
        this.loadQuestions()
    }
}
</script>
